var map = {
	"./BIFI-logo.svg": 947,
	"./avax-pairs/COM-AVAX.png": 948,
	"./avax-pairs/DAI-AVAX.png": 949,
	"./avax-pairs/ETH-AVAX.png": 950,
	"./avax-pairs/ETH-AVAX.svg": 951,
	"./avax-pairs/LINK-AVAX.svg": 952,
	"./avax-pairs/LYD-AVAX.png": 953,
	"./avax-pairs/OLIVE-AVAX.png": 954,
	"./avax-pairs/OLIVE-USDT.png": 955,
	"./avax-pairs/PNG-AVAX.png": 956,
	"./avax-pairs/PNG-AVAX.svg": 957,
	"./avax-pairs/SNOB-AVAX.svg": 958,
	"./avax-pairs/SNOB3P.png": 959,
	"./avax-pairs/SUSHI-AVAX.svg": 960,
	"./avax-pairs/UNI-AVAX.svg": 961,
	"./avax-pairs/USDT-AVAX.png": 962,
	"./avax-pairs/USDT-AVAX.svg": 963,
	"./avax-pairs/USDT-PNG.svg": 964,
	"./avax-pairs/WBTC-AVAX.svg": 965,
	"./avax-pairs/ZETH.svg": 966,
	"./binance-wallet.png": 967,
	"./bnb-pairs/AAVE-BNB.svg": 968,
	"./bnb-pairs/ADA-BNB.svg": 969,
	"./bnb-pairs/ALICE-BNB.svg": 970,
	"./bnb-pairs/ALPA-BNB.svg": 971,
	"./bnb-pairs/ALPACA-BNB.png": 972,
	"./bnb-pairs/ALPHA-BNB.svg": 973,
	"./bnb-pairs/APYS-BNB.svg": 974,
	"./bnb-pairs/ARPA-BNB.svg": 975,
	"./bnb-pairs/ASR-BNB.svg": 976,
	"./bnb-pairs/ATA-BNB.svg": 977,
	"./bnb-pairs/ATM-BNB.svg": 978,
	"./bnb-pairs/ATOM-BNB.svg": 979,
	"./bnb-pairs/AUTO-BNB.png": 980,
	"./bnb-pairs/AVAX-BNB.svg": 981,
	"./bnb-pairs/BAKE-BNB.png": 982,
	"./bnb-pairs/BALBT-BNB.svg": 983,
	"./bnb-pairs/BAND-BNB.svg": 984,
	"./bnb-pairs/BAT-BNB.svg": 985,
	"./bnb-pairs/BCH-BNB.svg": 986,
	"./bnb-pairs/BDO-BNB.svg": 987,
	"./bnb-pairs/BEL-BNB.svg": 988,
	"./bnb-pairs/BELT-BNB-BELT.png": 989,
	"./bnb-pairs/BELT-BNB.svg": 990,
	"./bnb-pairs/BFI-BNB.svg": 991,
	"./bnb-pairs/BHC-BNB.png": 992,
	"./bnb-pairs/BIFI-BNB.png": 993,
	"./bnb-pairs/BIFI-BNB.svg": 994,
	"./bnb-pairs/BITI-BNB.png": 995,
	"./bnb-pairs/BLIQ-BNB.png": 996,
	"./bnb-pairs/BLK-BNB.svg": 997,
	"./bnb-pairs/BLZ-BNB.svg": 998,
	"./bnb-pairs/BMXX-BNB.svg": 999,
	"./bnb-pairs/BONDLY-BNB.svg": 1000,
	"./bnb-pairs/BOPEN-BNB.svg": 1001,
	"./bnb-pairs/BOR-BNB.svg": 1002,
	"./bnb-pairs/BRY-BNB.svg": 1003,
	"./bnb-pairs/BSCX-BNB.svg": 1004,
	"./bnb-pairs/BTC-BNB.png": 1005,
	"./bnb-pairs/BTCB-BNB.svg": 1006,
	"./bnb-pairs/BTCST-BNB.svg": 1007,
	"./bnb-pairs/BTT-BNB.svg": 1008,
	"./bnb-pairs/BUNNY-BNB.svg": 1009,
	"./bnb-pairs/BUSD-BNB.png": 1010,
	"./bnb-pairs/BUSD-BNB.svg": 1011,
	"./bnb-pairs/BUX-BNB.svg": 1012,
	"./bnb-pairs/BXBTC-BNB.svg": 1013,
	"./bnb-pairs/CAKE-BNB.svg": 1014,
	"./bnb-pairs/CELR-BNB.svg": 1015,
	"./bnb-pairs/CGG-BNB.svg": 1016,
	"./bnb-pairs/COM-BNB.png": 1017,
	"./bnb-pairs/COMP-BNB.svg": 1018,
	"./bnb-pairs/COS-BNB.svg": 1019,
	"./bnb-pairs/COTI-BNB.svg": 1020,
	"./bnb-pairs/CRED-BNB.png": 1021,
	"./bnb-pairs/CTK-BNB.svg": 1022,
	"./bnb-pairs/CYC-BNB.svg": 1023,
	"./bnb-pairs/DAI-BNB.svg": 1024,
	"./bnb-pairs/DEGO-BNB.svg": 1025,
	"./bnb-pairs/DFT-BNB.svg": 1026,
	"./bnb-pairs/DITTO-BNB.svg": 1027,
	"./bnb-pairs/DODO-BNB.svg": 1028,
	"./bnb-pairs/DOGE-BNB-PCS.svg": 1029,
	"./bnb-pairs/DOGE-BNB.svg": 1030,
	"./bnb-pairs/DOT-BNB.svg": 1031,
	"./bnb-pairs/DRUGS-BNB.png": 1032,
	"./bnb-pairs/DUSK-BNB.svg": 1033,
	"./bnb-pairs/EASY-BNB.svg": 1034,
	"./bnb-pairs/EGLD-BNB.svg": 1035,
	"./bnb-pairs/EOS-BNB.svg": 1036,
	"./bnb-pairs/EPS-BNB.svg": 1037,
	"./bnb-pairs/ETC-BNB.svg": 1038,
	"./bnb-pairs/ETH-BNB.svg": 1039,
	"./bnb-pairs/EZ-BNB.svg": 1040,
	"./bnb-pairs/FIL-BNB.svg": 1041,
	"./bnb-pairs/FINE-BNB.svg": 1042,
	"./bnb-pairs/FRONT-BNB.svg": 1043,
	"./bnb-pairs/FTM-BNB.svg": 1044,
	"./bnb-pairs/FTS-BNB.svg": 1045,
	"./bnb-pairs/FUEL-BNB.png": 1046,
	"./bnb-pairs/GOLD-BNB.png": 1047,
	"./bnb-pairs/GUM-BNB.svg": 1048,
	"./bnb-pairs/GUNS-BNB.png": 1049,
	"./bnb-pairs/HARD-BNB.svg": 1050,
	"./bnb-pairs/HELMET-BNB.svg": 1051,
	"./bnb-pairs/HGET-BNB.svg": 1052,
	"./bnb-pairs/HYFI-BNB.svg": 1053,
	"./bnb-pairs/HZN-BNB.svg": 1054,
	"./bnb-pairs/INJ-BNB.svg": 1055,
	"./bnb-pairs/IOTA-BNB.svg": 1056,
	"./bnb-pairs/ITAM-BNB.svg": 1057,
	"./bnb-pairs/JBTCB-BNB.svg": 1058,
	"./bnb-pairs/JDOT-BNB.svg": 1059,
	"./bnb-pairs/JGN-BNB.png": 1060,
	"./bnb-pairs/JGN-BNB.svg": 1061,
	"./bnb-pairs/JTWT-BNB.svg": 1062,
	"./bnb-pairs/JULD-BNB.svg": 1063,
	"./bnb-pairs/JUNI-BNB.svg": 1064,
	"./bnb-pairs/JUV-BNB.svg": 1065,
	"./bnb-pairs/JXVS-BNB.svg": 1066,
	"./bnb-pairs/KALM-BNB.svg": 1067,
	"./bnb-pairs/KEBAB-BNB.png": 1068,
	"./bnb-pairs/KEYFI-BNB.svg": 1069,
	"./bnb-pairs/KTN-BNB.svg": 1070,
	"./bnb-pairs/LIEN-BNB.svg": 1071,
	"./bnb-pairs/LINK-BNB.svg": 1072,
	"./bnb-pairs/LIT-BNB.svg": 1073,
	"./bnb-pairs/LMT-BNB.svg": 1074,
	"./bnb-pairs/LTC-BNB.svg": 1075,
	"./bnb-pairs/LTO-BNB.svg": 1076,
	"./bnb-pairs/MATIC-BNB.svg": 1077,
	"./bnb-pairs/MBOX-BNB.svg": 1078,
	"./bnb-pairs/MDX-BNB.png": 1079,
	"./bnb-pairs/NAR-BNB.png": 1080,
	"./bnb-pairs/NAUT-BNB.svg": 1081,
	"./bnb-pairs/NEAR-BNB.svg": 1082,
	"./bnb-pairs/NRV-BNB.svg": 1083,
	"./bnb-pairs/ODDZ-BNB.svg": 1084,
	"./bnb-pairs/OG-BNB.svg": 1085,
	"./bnb-pairs/ONT-BNB.svg": 1086,
	"./bnb-pairs/PBTC-BNB.svg": 1087,
	"./bnb-pairs/PERL-BNB.svg": 1088,
	"./bnb-pairs/POPEN-BNB.svg": 1089,
	"./bnb-pairs/PSG-BNB.svg": 1090,
	"./bnb-pairs/REEF-BNB.svg": 1091,
	"./bnb-pairs/SFP-BNB.svg": 1092,
	"./bnb-pairs/SHIB-BNB.svg": 1093,
	"./bnb-pairs/SNX-BNB.svg": 1094,
	"./bnb-pairs/SOAK-BNB.svg": 1095,
	"./bnb-pairs/SPG-BNB.svg": 1096,
	"./bnb-pairs/STEAM-BNB.svg": 1097,
	"./bnb-pairs/SUTER-BNB.svg": 1098,
	"./bnb-pairs/SWAMP-BNB.svg": 1099,
	"./bnb-pairs/SWGB-BNB.svg": 1100,
	"./bnb-pairs/SWINGBY-BNB.svg": 1101,
	"./bnb-pairs/SWIRL-BNB.png": 1102,
	"./bnb-pairs/SWTH-BNB.svg": 1103,
	"./bnb-pairs/SXP-BNB.svg": 1104,
	"./bnb-pairs/TDOGE-BNB.svg": 1105,
	"./bnb-pairs/TEN-BNB.svg": 1106,
	"./bnb-pairs/THUGS-BNB.png": 1107,
	"./bnb-pairs/TKO-BNB.svg": 1108,
	"./bnb-pairs/TLM-BNB.svg": 1109,
	"./bnb-pairs/TRADE-BNB.svg": 1110,
	"./bnb-pairs/TRX-BNB.svg": 1111,
	"./bnb-pairs/TWT-BNB.svg": 1112,
	"./bnb-pairs/TYPH-BNB.png": 1113,
	"./bnb-pairs/UNFI-BNB.svg": 1114,
	"./bnb-pairs/UNI-BNB.svg": 1115,
	"./bnb-pairs/USDC-BNB.svg": 1116,
	"./bnb-pairs/USDT-BNB.svg": 1117,
	"./bnb-pairs/VAPOR-BNB.png": 1118,
	"./bnb-pairs/VIDT-BNB.svg": 1119,
	"./bnb-pairs/VRT-BNB.svg": 1120,
	"./bnb-pairs/WATCH-BNB-APE.svg": 1121,
	"./bnb-pairs/WATCH-BNB.svg": 1122,
	"./bnb-pairs/WEX-BNB.png": 1123,
	"./bnb-pairs/WIN-BNB.svg": 1124,
	"./bnb-pairs/WSOTE-BNB.svg": 1125,
	"./bnb-pairs/XED-BNB.svg": 1126,
	"./bnb-pairs/XEND-BNB.svg": 1127,
	"./bnb-pairs/XRP-BNB.svg": 1128,
	"./bnb-pairs/XTZ-BNB.svg": 1129,
	"./bnb-pairs/XVS-BNB.svg": 1130,
	"./bnb-pairs/YFI-BNB.svg": 1131,
	"./bnb-pairs/YFII-BNB.svg": 1132,
	"./bnb-pairs/ZEC-BNB.svg": 1133,
	"./bnb-pairs/ZEE-BNB.svg": 1134,
	"./bnb-pairs/ZIL-BNB.svg": 1135,
	"./bnb-pairs/bROOBEE-BNB.svg": 1136,
	"./bnb-pairs/bTRI-BNB.png": 1137,
	"./bnb-pairs/pCWS-BNB.svg": 1138,
	"./bnb-pairs/typh-bnb.svg": 1139,
	"./busd-pairs/ADA-BUSD.png": 1140,
	"./busd-pairs/ALPACA-BUSD.svg": 1141,
	"./busd-pairs/BAKE-BUSD.png": 1142,
	"./busd-pairs/BCFX-BUSD.svg": 1143,
	"./busd-pairs/BIFI-BUSD.png": 1144,
	"./busd-pairs/BTCB-BUSD.svg": 1145,
	"./busd-pairs/BTR-BUSD.svg": 1146,
	"./busd-pairs/BUSD-USDC.svg": 1147,
	"./busd-pairs/DAI-BUSD.png": 1148,
	"./busd-pairs/DAI-BUSD.svg": 1149,
	"./busd-pairs/DEXE-BUSD.svg": 1150,
	"./busd-pairs/DFD-BUSD.svg": 1151,
	"./busd-pairs/FOR-BUSD.svg": 1152,
	"./busd-pairs/HAKKA-BUSD.svg": 1153,
	"./busd-pairs/HOO-BUSD.svg": 1154,
	"./busd-pairs/IOTX-BUSD.svg": 1155,
	"./busd-pairs/KEBAB-BUSD.png": 1156,
	"./busd-pairs/KUN-BUSD.svg": 1157,
	"./busd-pairs/LINA-BUSD.svg": 1158,
	"./busd-pairs/LTC-BUSD.png": 1159,
	"./busd-pairs/MATH-BUSD.svg": 1160,
	"./busd-pairs/MDX-BUSD.png": 1161,
	"./busd-pairs/MTRG-BUSD.svg": 1162,
	"./busd-pairs/MX-BUSD.svg": 1163,
	"./busd-pairs/NULS-BUSD.svg": 1164,
	"./busd-pairs/OIN-BUSD.svg": 1165,
	"./busd-pairs/ONE-BUSD.svg": 1166,
	"./busd-pairs/PMON-BUSD.svg": 1167,
	"./busd-pairs/QKC-BUSD.svg": 1168,
	"./busd-pairs/RAMP-BUSD.svg": 1169,
	"./busd-pairs/SWAMP-BUSD.svg": 1170,
	"./busd-pairs/TPT-BUSD.svg": 1171,
	"./busd-pairs/TUSD-BUSD.svg": 1172,
	"./busd-pairs/TXL-BUSD.svg": 1173,
	"./busd-pairs/UBXT-BUSD.svg": 1174,
	"./busd-pairs/USDC-BUSD.svg": 1175,
	"./busd-pairs/USDT-BUSD.png": 1176,
	"./busd-pairs/USDT-BUSD.svg": 1177,
	"./busd-pairs/UST-BUSD.svg": 1178,
	"./busd-pairs/VAI-BUSD.svg": 1179,
	"./busd-pairs/WELL-BUSD.svg": 1180,
	"./busd-pairs/WMASS-BUSD.svg": 1181,
	"./busd-pairs/XMARK-BUSD.svg": 1182,
	"./busd-pairs/XRP-BUSD.png": 1183,
	"./cake-pairs/BROOBEE-CAKE.svg": 1184,
	"./cake-pairs/CAKE-BUSD.svg": 1185,
	"./cake-pairs/NAR-CAKE.svg": 1186,
	"./cake-pairs/NYA-CAKE.svg": 1187,
	"./cake-pairs/STAX-CAKE.svg": 1188,
	"./cake-pairs/ampl-bsc-mp-busd.svg": 1189,
	"./cake-pairs/btcb-eth.svg": 1190,
	"./cake-pairs/chr-busd.svg": 1191,
	"./cake-pairs/deri-busd.svg": 1192,
	"./cake-pairs/eth-usdc.svg": 1193,
	"./cake-pairs/hotcross-bnb.svg": 1194,
	"./cake-pairs/rfox-bnb.svg": 1195,
	"./crow/crow.png": 1196,
	"./degens/ADA-BNB.svg": 1197,
	"./degens/BANANA-DOT-BNB.svg": 1198,
	"./degens/BANANA-SUSHI-BNB.svg": 1199,
	"./degens/BANANA-XRP-BNB.svg": 1200,
	"./degens/BANANA.svg": 1201,
	"./degens/BGO.png": 1202,
	"./degens/BIFI-BNB-banana.svg": 1203,
	"./degens/BIFI-BNB.svg": 1204,
	"./degens/BITI.png": 1205,
	"./degens/BLZD-BNB.png": 1206,
	"./degens/BLZD-BUSD.png": 1207,
	"./degens/BLZD.png": 1208,
	"./degens/DND.png": 1209,
	"./degens/FTS-BNB.svg": 1210,
	"./degens/FUEL-BNB.svg": 1211,
	"./degens/GOAL-BUSD.png": 1212,
	"./degens/IRON.png": 1213,
	"./degens/LINK-BNB.svg": 1214,
	"./degens/NAUT.png": 1215,
	"./degens/PALM.png": 1216,
	"./degens/SAT-BNB.png": 1217,
	"./degens/SAT-BUSD.png": 1218,
	"./degens/SBGO.png": 1219,
	"./degens/SOUP-BNB.svg": 1220,
	"./degens/SOUPS-BNB.svg": 1221,
	"./degens/SPACE-BNB.png": 1222,
	"./degens/SPACE-BUSD.png": 1223,
	"./degens/STEEL.png": 1224,
	"./degens/WINGS-BNB-BUSD.svg": 1225,
	"./degens/WINGS-BNB.svg": 1226,
	"./degens/WINGS-BUSD.svg": 1227,
	"./degens/WINGS-USDC-BUSD.svg": 1228,
	"./degens/WINGS.svg": 1229,
	"./degens/ZEFI-BNB.svg": 1230,
	"./degens/ZEFI-BUSD.svg": 1231,
	"./degens/ape-bnb.png": 1232,
	"./degens/banana-bnb.svg": 1233,
	"./degens/banana-busd.svg": 1234,
	"./degens/banana-ltc-bnb.svg": 1235,
	"./degens/brew-bnb.svg": 1236,
	"./degens/brew-busd.svg": 1237,
	"./degens/garuda-bnb.png": 1238,
	"./degens/garuda-usdc.png": 1239,
	"./degens/garuda-usdt.png": 1240,
	"./degens/grand-bnb.png": 1241,
	"./degens/grand.png": 1242,
	"./degens/mash-bnb.png": 1243,
	"./degens/mash-busd.png": 1244,
	"./degens/mash.png": 1245,
	"./degens/mfrm-bnb.png": 1246,
	"./degens/palm-bnb.png": 1247,
	"./degens/palm-busd.png": 1248,
	"./degens/panther-bnb.png": 1249,
	"./degens/panther-busd.png": 1250,
	"./degens/ramen-bnb.svg": 1251,
	"./degens/ramen-busd.svg": 1252,
	"./degens/salt-bnb.png": 1253,
	"./degens/salt-busd.png": 1254,
	"./degens/sdump-bnb.png": 1255,
	"./degens/sdump-busd.png": 1256,
	"./degens/slime-bnb.png": 1257,
	"./degens/slime-busd.png": 1258,
	"./degens/tndr-bnb.png": 1259,
	"./degens/tndr-busd.png": 1260,
	"./degens/tofy-bnb.png": 1261,
	"./degens/tofy-mash.png": 1262,
	"./degens/tofy.png": 1263,
	"./eth-pairs/ADA-ETH.svg": 1264,
	"./eth-pairs/BETH-ETH.svg": 1265,
	"./eth-pairs/BTCB-ETH.svg": 1266,
	"./eth-pairs/ETH-BNB.png": 1267,
	"./eth-pairs/ETH-BTC.png": 1268,
	"./fantom/AAVE-FTM.png": 1269,
	"./fantom/ANY-FTM.png": 1270,
	"./fantom/BADGER-FTM.png": 1271,
	"./fantom/BAND-FTM.png": 1272,
	"./fantom/BIFI-FTM.png": 1273,
	"./fantom/BNB-FTM.png": 1274,
	"./fantom/BOO-FTM.png": 1275,
	"./fantom/BOO.png": 1276,
	"./fantom/BTC-FTM.png": 1277,
	"./fantom/COVER-FTM.png": 1278,
	"./fantom/CREAM-FTM.png": 1279,
	"./fantom/CRV-FTM.png": 1280,
	"./fantom/DAI-FTM.png": 1281,
	"./fantom/EST-FTM.png": 1282,
	"./fantom/EST.png": 1283,
	"./fantom/ETH-FTM.png": 1284,
	"./fantom/FROYO-3Pool.png": 1285,
	"./fantom/FROYO.png": 1286,
	"./fantom/ICE-FTM.png": 1287,
	"./fantom/LINK-FTM.png": 1288,
	"./fantom/SNX-FTM.png": 1289,
	"./fantom/SUSHI-FTM.png": 1290,
	"./fantom/TOMB-FTM.png": 1291,
	"./fantom/TSHARE-FTM.png": 1292,
	"./fantom/USDC-FTM.png": 1293,
	"./fantom/USDT-FTM.png": 1294,
	"./fantom/WOOFY-FTM.png": 1295,
	"./fantom/YFI-FTM.png": 1296,
	"./heco/AAVE-USDT.svg": 1297,
	"./heco/BAL-USDT.svg": 1298,
	"./heco/ETH-USDT.png": 1299,
	"./heco/ETH-WHT.svg": 1300,
	"./heco/HBCH-USDT.svg": 1301,
	"./heco/HBTC-USDT.png": 1302,
	"./heco/HBTC-WHT.svg": 1303,
	"./heco/HDOT-USDT.svg": 1304,
	"./heco/HFI-HT.png": 1305,
	"./heco/HFI-HUSD.png": 1306,
	"./heco/HFIL-USDT.svg": 1307,
	"./heco/HLTC-USDT.svg": 1308,
	"./heco/HPT-USDT.svg": 1309,
	"./heco/HUSD-USDT.svg": 1310,
	"./heco/HUSD.png": 1311,
	"./heco/LAVA-HT.svg": 1312,
	"./heco/LAVA-USDT.svg": 1313,
	"./heco/LAVA.png": 1314,
	"./heco/LHB-USDT.svg": 1315,
	"./heco/LHB-WHT.png": 1316,
	"./heco/LINK-USDT.svg": 1317,
	"./heco/MDX-USDT.png": 1318,
	"./heco/MDX-WHT.png": 1319,
	"./heco/SNX-USDT.svg": 1320,
	"./heco/UNI-USDT.svg": 1321,
	"./heco/WHT-HUSD.png": 1322,
	"./heco/WHT-USDT.png": 1323,
	"./heco/YFI-USDT.svg": 1324,
	"./heco/fHT.png": 1325,
	"./heco/fUNI.png": 1326,
	"./kardiachain/kai-beco.png": 1327,
	"./kebab/ETH-BTCB.png": 1328,
	"./kebab/KEBAB-BTCB.png": 1329,
	"./kebab/USDT-BUSD.png": 1330,
	"./polygon/AAVE-ETH.png": 1331,
	"./polygon/ADDY.png": 1332,
	"./polygon/ANY-QUICK.png": 1333,
	"./polygon/AZUKI-ETH.png": 1334,
	"./polygon/BIFI-ETH.png": 1335,
	"./polygon/BIFI-MATIC.png": 1336,
	"./polygon/BIFI-MUST.png": 1337,
	"./polygon/BIFI-QUICK.png": 1338,
	"./polygon/BTC-USDC.png": 1339,
	"./polygon/CC10-ETH.png": 1340,
	"./polygon/CC10-QUICK.png": 1341,
	"./polygon/CEL-ETH.png": 1342,
	"./polygon/CRV-ETH.png": 1343,
	"./polygon/CURVE-3Pool.png": 1344,
	"./polygon/DEFI5-ETH.png": 1345,
	"./polygon/DEFI5-QUICK.png": 1346,
	"./polygon/DEGEN-ETH.png": 1347,
	"./polygon/DEGEN-QUICK.png": 1348,
	"./polygon/DOKI-ETH.png": 1349,
	"./polygon/ETH-BTC.png": 1350,
	"./polygon/ETH-DAI.png": 1351,
	"./polygon/ETH-FIL.png": 1352,
	"./polygon/ETH-MATIC.png": 1353,
	"./polygon/ETH-USDT.png": 1354,
	"./polygon/FFF-QUICK.png": 1355,
	"./polygon/FISH-MATIC.svg": 1356,
	"./polygon/FRAX-FXS.png": 1357,
	"./polygon/FRAX-QUICK.png": 1358,
	"./polygon/FRAX-USDC.png": 1359,
	"./polygon/GRT-ETH.png": 1360,
	"./polygon/IRON-ETH.png": 1361,
	"./polygon/IRON-USDC.png": 1362,
	"./polygon/IRON.png": 1363,
	"./polygon/KRILL-USDC.png": 1364,
	"./polygon/LINK-ETH.png": 1365,
	"./polygon/LINK-QUICK.png": 1366,
	"./polygon/MATIC-USDC.png": 1367,
	"./polygon/MATIC-WOOFY.png": 1368,
	"./polygon/MIMATIC-USDC.png": 1369,
	"./polygon/MUST-ETH.png": 1370,
	"./polygon/MUST-MATIC.png": 1371,
	"./polygon/PZAP-MATIC.png": 1372,
	"./polygon/PZAP-USDC.png": 1373,
	"./polygon/QUICK-ETH.png": 1374,
	"./polygon/QUICK-MATIC.png": 1375,
	"./polygon/QUICK-UNI.png": 1376,
	"./polygon/SNX-ETH.png": 1377,
	"./polygon/TITAN-ETH.png": 1378,
	"./polygon/TITAN-IRON.png": 1379,
	"./polygon/TITAN-MATIC.png": 1380,
	"./polygon/TITAN.png": 1381,
	"./polygon/UBT-ETH.png": 1382,
	"./polygon/USDC-DAI.png": 1383,
	"./polygon/USDC-ETH.png": 1384,
	"./polygon/USDC-MUST.png": 1385,
	"./polygon/USDC-USDT.png": 1386,
	"./polygon/VISION-ETH.png": 1387,
	"./polygon/VISION-QUICK.png": 1388,
	"./polygon/WEX-MATIC.png": 1389,
	"./polygon/WEX-USDC.png": 1390,
	"./polygon/WEX.png": 1391,
	"./polygon/WISE-ETH.png": 1392,
	"./polygon/mOCEAN-MATIC.png": 1393,
	"./polygon/maUSDC-USDC.png": 1394,
	"./polygon/renDOGE-ETH.png": 1395,
	"./single-assets/AAVE.png": 252,
	"./single-assets/AAVE.svg": 477,
	"./single-assets/ADA.svg": 478,
	"./single-assets/ANY.png": 253,
	"./single-assets/ATOM.png": 254,
	"./single-assets/AVAX.png": 255,
	"./single-assets/BAKE.png": 256,
	"./single-assets/BANANA.svg": 479,
	"./single-assets/BCH.svg": 480,
	"./single-assets/BDO.png": 257,
	"./single-assets/BDS.png": 258,
	"./single-assets/BECO.png": 259,
	"./single-assets/BETH.png": 260,
	"./single-assets/BHC.png": 261,
	"./single-assets/BIFI.png": 262,
	"./single-assets/BLK.png": 263,
	"./single-assets/BNB.png": 264,
	"./single-assets/BORING.png": 265,
	"./single-assets/BTCB.svg": 481,
	"./single-assets/BTD.png": 266,
	"./single-assets/BTS.png": 267,
	"./single-assets/BUNNY.png": 268,
	"./single-assets/BURGER.png": 269,
	"./single-assets/BUSD.png": 270,
	"./single-assets/BUSD.svg": 482,
	"./single-assets/CAKE.svg": 349,
	"./single-assets/CTK.png": 271,
	"./single-assets/DAI.svg": 483,
	"./single-assets/DFL.png": 272,
	"./single-assets/DG.png": 273,
	"./single-assets/DNFT.png": 274,
	"./single-assets/DOT.png": 275,
	"./single-assets/DPET.png": 276,
	"./single-assets/DRAGON.png": 277,
	"./single-assets/DRUGS.png": 278,
	"./single-assets/ETH.png": 279,
	"./single-assets/ETH.svg": 484,
	"./single-assets/FAM.png": 280,
	"./single-assets/FFF.png": 281,
	"./single-assets/FIL.svg": 485,
	"./single-assets/FISH.svg": 486,
	"./single-assets/FTM.png": 282,
	"./single-assets/HAI.png": 283,
	"./single-assets/HARD.png": 284,
	"./single-assets/HBTC.png": 285,
	"./single-assets/HPS.png": 286,
	"./single-assets/HT.png": 287,
	"./single-assets/HTB.svg": 487,
	"./single-assets/HUSD.png": 288,
	"./single-assets/ICA.svg": 488,
	"./single-assets/INCH.png": 289,
	"./single-assets/INJ.png": 290,
	"./single-assets/JETS.png": 291,
	"./single-assets/JULD.png": 292,
	"./single-assets/KABA.png": 293,
	"./single-assets/KAI.png": 294,
	"./single-assets/KDX.png": 295,
	"./single-assets/KEBAB.png": 296,
	"./single-assets/KPHI.png": 297,
	"./single-assets/KSC.png": 298,
	"./single-assets/KUSD.png": 299,
	"./single-assets/LINK.png": 300,
	"./single-assets/LPDI.png": 301,
	"./single-assets/LTC.svg": 489,
	"./single-assets/LTD.png": 302,
	"./single-assets/MARSH.png": 303,
	"./single-assets/MATIC.png": 304,
	"./single-assets/MATIC.svg": 490,
	"./single-assets/MDX.png": 305,
	"./single-assets/MERL.svg": 491,
	"./single-assets/MOWA.png": 306,
	"./single-assets/MSC.png": 307,
	"./single-assets/MSS.png": 308,
	"./single-assets/NUTS.png": 309,
	"./single-assets/NYA.png": 310,
	"./single-assets/NYAC.png": 311,
	"./single-assets/NYAS.png": 312,
	"./single-assets/O3.png": 313,
	"./single-assets/PBNB.png": 314,
	"./single-assets/PMP.svg": 492,
	"./single-assets/POLYGON.png": 315,
	"./single-assets/PUP.png": 316,
	"./single-assets/PolyDoge.png": 317,
	"./single-assets/QUICK.png": 318,
	"./single-assets/RABBIT.svg": 493,
	"./single-assets/RAMP.png": 319,
	"./single-assets/SBDO.png": 320,
	"./single-assets/SEN.png": 321,
	"./single-assets/SFP.png": 322,
	"./single-assets/SMART.png": 323,
	"./single-assets/SNX.png": 324,
	"./single-assets/SOAK.png": 325,
	"./single-assets/SPIRIT.png": 326,
	"./single-assets/STEEL.png": 327,
	"./single-assets/SUSHI.png": 328,
	"./single-assets/SWAMP.svg": 494,
	"./single-assets/SXP.svg": 495,
	"./single-assets/TENFI.png": 329,
	"./single-assets/THG.png": 330,
	"./single-assets/TPH.png": 331,
	"./single-assets/TYPH.png": 332,
	"./single-assets/UNI.png": 333,
	"./single-assets/USDC.png": 334,
	"./single-assets/USDC.svg": 496,
	"./single-assets/USDT.png": 335,
	"./single-assets/USDT.svg": 497,
	"./single-assets/VNDC.webp": 498,
	"./single-assets/WAULTx.svg": 499,
	"./single-assets/WBNB.svg": 500,
	"./single-assets/WBTC.png": 336,
	"./single-assets/WBTC.svg": 501,
	"./single-assets/WEX.svg": 502,
	"./single-assets/WOO.svg": 503,
	"./single-assets/WOOFY.png": 337,
	"./single-assets/XRP.svg": 504,
	"./single-assets/XTZ.png": 338,
	"./single-assets/XVS.png": 339,
	"./single-assets/YELD.png": 340,
	"./single-assets/YFI.png": 341,
	"./single-assets/ZBTC.svg": 505,
	"./single-assets/ZETH.svg": 506,
	"./single-assets/cakeHARD.png": 342,
	"./single-assets/cakeROOBEE.png": 343,
	"./single-assets/cakeSTAX.png": 344,
	"./single-assets/cakeTWT.png": 345,
	"./single-assets/cakebROOBEE.png": 346,
	"./single-assets/fUSDT.png": 347,
	"./single-assets/ibBTC.svg": 507,
	"./single-assets/miMATIC.png": 348,
	"./single-assets/rUSD.svg": 508,
	"./single-assets/sALPACA.svg": 509,
	"./sleepearn/sleepearn-logo.jpg": 248,
	"./sleepearn/sleepearn_bg.jpg": 1396,
	"./stake/apeswap/background.png": 1397,
	"./stake/apeswap/logo.png": 1398,
	"./stake/apyswap/background.png": 1399,
	"./stake/apyswap/logo.png": 1400,
	"./stake/astronaut/background.png": 1401,
	"./stake/astronaut/logo.png": 1402,
	"./stake/beefy/background.png": 1403,
	"./stake/beefy/beefyfinance.png": 1404,
	"./stake/billionhappiness/background.png": 1405,
	"./stake/billionhappiness/logo.png": 1406,
	"./stake/bingo/background.png": 1407,
	"./stake/bingo/logo.png": 1408,
	"./stake/biticity/background.png": 1409,
	"./stake/biticity/logo.png": 1410,
	"./stake/boost.svg": 187,
	"./stake/cafeswap/background.png": 1411,
	"./stake/cafeswap/brew.png": 1412,
	"./stake/cafeswap/cafeswap.png": 1413,
	"./stake/crowfinance/background.png": 1414,
	"./stake/crowfinance/crow.png": 1415,
	"./stake/crowfinance/crowfinance.png": 1416,
	"./stake/dopple/background.png": 1417,
	"./stake/dopple/logo.png": 1418,
	"./stake/dumpling/background.png": 1419,
	"./stake/dumpling/logo.png": 1420,
	"./stake/esterfinance/background.png": 1421,
	"./stake/esterfinance/logo.png": 1422,
	"./stake/f1.png": 1423,
	"./stake/fanatics/logo.png": 1424,
	"./stake/fire.png": 350,
	"./stake/garuda/logo.png": 1425,
	"./stake/grandbanks/background.png": 1426,
	"./stake/grandbanks/logo.png": 1427,
	"./stake/icarus/background.png": 1428,
	"./stake/icarus/logo.png": 1429,
	"./stake/ironfinance/background.png": 1430,
	"./stake/ironfinance/logo.png": 1431,
	"./stake/jetswap/background.png": 1432,
	"./stake/jetswap/logo.png": 1433,
	"./stake/launchpool.png": 1434,
	"./stake/mash/background.png": 1435,
	"./stake/mash/logo.png": 1436,
	"./stake/memefarm/ape.png": 1437,
	"./stake/memefarm/background.png": 1438,
	"./stake/memefarm/logo.png": 1439,
	"./stake/merlin/background.png": 1440,
	"./stake/merlin/logo.png": 1441,
	"./stake/panther/background.png": 1442,
	"./stake/panther/logo.png": 1443,
	"./stake/polygon/background.png": 1444,
	"./stake/polygon/logo.png": 1445,
	"./stake/ramenswap/background.png": 1446,
	"./stake/ramenswap/ramen.png": 1447,
	"./stake/ramenswap/ramenswap.png": 1448,
	"./stake/safefarm/background.png": 1449,
	"./stake/safefarm/logo.png": 1450,
	"./stake/saltswap/background.png": 1451,
	"./stake/saltswap/salt.png": 1452,
	"./stake/saltswap/saltswap.png": 1453,
	"./stake/satis/background.png": 1454,
	"./stake/satis/logo.png": 1455,
	"./stake/slimefinance/background.png": 1456,
	"./stake/slimefinance/logo.png": 1457,
	"./stake/slimefinance/slime.png": 1458,
	"./stake/soup/background.png": 1459,
	"./stake/soup/logo.png": 1460,
	"./stake/space/background.png": 1461,
	"./stake/space/logo.png": 1462,
	"./stake/squirrel/background.png": 1463,
	"./stake/squirrel/logo.png": 1464,
	"./stake/squirrel/nuts.png": 1465,
	"./stake/swirl/background.png": 1466,
	"./stake/swirl/logo.png": 1467,
	"./stake/tenfi/background.png": 1468,
	"./stake/tenfi/logo.png": 1469,
	"./stake/thunder/background.png": 1470,
	"./stake/thunder/logo.png": 1471,
	"./stake/thypoon/background.png": 1472,
	"./stake/thypoon/logo.png": 1473,
	"./stake/tombfinance/background.png": 1474,
	"./stake/tombfinance/logo.png": 1475,
	"./stake/xbtc/background.png": 1476,
	"./stake/xbtc/logo.png": 1477,
	"./stake/yieldbay/background.png": 1478,
	"./stake/yieldbay/logo.png": 1479,
	"./stake/zcore/background.png": 1480,
	"./stake/zcore/logo.png": 1481,
	"./uncategorized/BADGER-BTCB.svg": 1482,
	"./uncategorized/BAT-BAKE.svg": 1483,
	"./uncategorized/BDIGG-BTCB.svg": 1484,
	"./uncategorized/BELT-VENUSBLP.png": 1485,
	"./uncategorized/BETH-ETH.svg": 1486,
	"./uncategorized/COMP-ETH.svg": 1487,
	"./uncategorized/DOPPLE-DOLLY-LP.svg": 1488,
	"./uncategorized/DOPPLE-DOP-LP.svg": 1489,
	"./uncategorized/DOPPLE-UST-LP.png": 1490,
	"./uncategorized/EPS-FUSDT.png": 1491,
	"./uncategorized/EPS.png": 1492,
	"./uncategorized/EPS3.png": 1493,
	"./uncategorized/ETH-USDT.png": 1494,
	"./uncategorized/PNT-PBTC.svg": 1495,
	"./uncategorized/SUSHI-ETH.svg": 1496,
	"./uncategorized/TBTC-BTCB.svg": 1497,
	"./uncategorized/THUGS-NAR.png": 1498,
	"./uncategorized/bTRI-CRED.png": 1499,
	"./uncategorized/renBTC-BTC.png": 1500,
	"./usdt-pairs/ALPACA-USDT.png": 1501,
	"./usdt-pairs/BIFI-USDT.png": 1502,
	"./usdt-pairs/BNB-USDT.png": 1503,
	"./usdt-pairs/BTCB-USDT.svg": 1504,
	"./usdt-pairs/ETH-USDT.svg": 1505,
	"./usdt-pairs/FIL-USDT.png": 1506,
	"./usdt-pairs/LHB-USDT.png": 1507,
	"./usdt-pairs/LYD-USDT.png": 1508,
	"./usdt-pairs/MATIC-USDT.png": 1509,
	"./usdt-pairs/SHIB-USDT.png": 1510,
	"./usdt-pairs/WEX-USDT.png": 1511,
	"./ust-pairs/MAMZN-UST.svg": 1512,
	"./ust-pairs/MCOIN-UST.svg": 1513,
	"./ust-pairs/MGOOGL-UST.svg": 1514,
	"./ust-pairs/MIR-UST.svg": 1515,
	"./ust-pairs/MNFLX-UST.svg": 1516,
	"./ust-pairs/MTSLA-UST.svg": 1517,
	"./wallets/binance-wallet.png": 1518,
	"./wallets/math-wallet.svg": 1519,
	"./wallets/metamask.png": 1520,
	"./wallets/metamask.svg": 1521,
	"./wallets/safepal-wallet.svg": 1522,
	"./wallets/trust-wallet.svg": 1523
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 105;